




import { Component, Vue, Prop } from 'vue-property-decorator';
import { Quote } from '@/models/quote';

@Component
export default class QuoteStatusLabel extends Vue {
    @Prop({ required: true }) public quote: Quote;

    public get className(): { [key: string]: boolean } {
        switch (this.quote.status) {
        case 0:
            return { 'label-info': true };
        case 1:
            return { 'label-warning': true };
        case 2:
            return { 'label-danger': true };
        case 3:
            return { 'label-primary': true };
        case 4:
            return { 'label-success': true };
        case 5:
            return { 'label-success': true };
        default:
            return { 'label-default': true };
        }
    }
    public get description(): string {
        switch (this.quote.status) {
        case 0:
            return `Awaiting approval`;
        case 1:
            return `Approved`;
        case 2:
            return `Rejected`;
        case 3:
            return `Order placed`;
        case 4:
            return `Order received`;
        case 5:
            return `Order delivered`;
        default:
            return `Unknown`;
        }
    }
}
